import type { ReactNode } from "react"
import StoreProvider from "../StoreProvider"
import { AuthWrapper } from "@/auth"
import { ErrorBoundary } from "@/monitoring"
import { UiProvider } from "@/ui"

type Props = {
  children: ReactNode
}

export default function Root({ children }: Props) {
  return (
    <ErrorBoundary>
      <StoreProvider>
        <UiProvider>
          <AuthWrapper>{children}</AuthWrapper>
        </UiProvider>
      </StoreProvider>
    </ErrorBoundary>
  )
}
